exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-architecture-jsx": () => import("./../../../src/pages/architecture.jsx" /* webpackChunkName: "component---src-pages-architecture-jsx" */),
  "component---src-pages-art-jsx": () => import("./../../../src/pages/art.jsx" /* webpackChunkName: "component---src-pages-art-jsx" */),
  "component---src-pages-impressum-jsx": () => import("./../../../src/pages/impressum.jsx" /* webpackChunkName: "component---src-pages-impressum-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

